// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__Omaky","title":"card_title__1ql-_","inActive":"card_inActive__1q-IW"};